<template>
  <div class="register register-form-com">
    <el-form :model="regist" ref="registerForm" :rules="rules" status-icon class="regist-form">
      <p class="pop-title">{{ $t('messages.register.lastStep') }}</p>
      <el-form-item prop="username">
        <label class="form-label">{{ $t('messages.register.name') }}</label>
        <el-input v-model="regist.username" :placeholder="$t('messages.register.fullname')"></el-input>
      </el-form-item>
      <el-form-item prop="email" v-if="!$store.state.profile.email">
        <label class="form-label">{{ $t('messages.login.email') }}</label>
        <el-input
          v-model="regist.email"
          type="email"
          :placeholder="$t('messages.register.emaTip')"
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="phone"
        class="application-number application-number2"
        v-if="!$store.state.profile.phone"
      >
        <label class="form-label">{{ $t('messages.register.phoneTip2') }}</label>
        <el-input v-model="regist.phone" :placeholder="$t('messages.register.phoneTip')">
          <el-select
            v-model="area"
            slot="prepend"
            size="medium"
            filterable
            @focus="handleSetOptionWidth"
            popper-class="app-select area-code-select"
            :placeholder="$t('messages.other.other54')"
          >
            <el-option
              v-for="(item, i) in areaCodeList"
              :key="i"
              :label="item.code + '     ' + item.country"
              :value="item.country"
            >
              <p class="option-p">
                <span>{{ item.code }}</span>
                <span>{{ item.country }}</span>
              </p>
            </el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item prop="contact_number" class="application-number">
        <label class="form-label">{{ $t('messages.register.contact') }}</label>
        <el-input v-model="regist.contact_number" :placeholder="$t('messages.register.contact2')">
          <el-select
            v-model="regist.contact_type"
            slot="prepend"
            :placeholder="$t('messages.myCampaign.list11')"
            popper-class="app-select"
            @change="changeContactType"
            ref="contact_type"
          >
            <el-option
              v-for="item in applications"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <img
                :src="item.src"
                style="width: 16px;height: 16px;margin-right: 16px;vertical-align: -3px;"
              />
              <span>{{ item.label }}</span>
            </el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item prop="product_url" class="apps-options-item">
        <label class="form-label" style="width: 100%;">{{ $t('messages.register.andapp') }}</label>
        <el-select
          :placeholder="$t('messages.home.tip52')"
          v-model="regist.country"
          size="medium"
          filterable
          class="item1"
        >
          <el-option
            v-for="(item, i) in countryOptions"
            :key="i"
            :label="item.name"
            :value="item.id"
            :style="{ width: selectOptionWidth || 'auto' }"
          ></el-option>
        </el-select>
        <el-input @change="changeAppStoreUrl" @input="handleUrlInput" 
          style="width: 320px;" ref="addAppInputRef" v-model.trim="regist.product_url" 
          :placeholder="$t('messages.home.tip19')"></el-input>
        <!-- <el-select
          placeholder="Please enter an app name / package"
          v-model="regist.product_url"
          filterable
          remote
          :remote-method="getAppList"
          class="item2"
        >
          <div slot="prefix" class="app-select-prefix-icon" v-if="selectObj.imgUrl">
            <img :src="selectObj.imgUrl" alt="icon url" width="22px" />
          </div>
          <el-option
            v-for="(item, i) in AppOptions"
            :key="i"
            :label="item.name"
            :value="item.gp_url"
            class="app-select-option"
            :style="{ width: selectOptionWidth || 'auto' }"
          >
            <img :src="item.icon" alt="icon url" class="img" />
            <p class="name">{{ item.name }}</p>
          </el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item>
        <el-button class="signup-btn" type="primary" @click="signUp">
          {{ $t('messages.register.btnT') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { countryAll, countryAllCN } from '@/js/varible'
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'
import { omit } from 'lodash'
export default {
  data() {
    return {
      regist: {
        username: '',
        email: '',
        contact_type: 3,
        contact_number: '',
        phone: '',
        product_url: '',
        country: '',
      },
      selectObj: {
        imgUrl: '',
      },
      urlErr: '',
      urlErrTip: '',
      area: '',
      rules: {
        username: [
          this.createRequiredRule(this,'messages.tipError.emptyErr'),
          {
            validator: (rule, value, callback) => {
              var reg2 = new RegExp(
                '[`~!@#$^&*()=|{}:;,\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“。，、？]'
              )
              if (reg2.test(value)) {
                callback(
                  new Error(
                    'Only letters,numbers,spaces and chinese characters are allowed in Name.'
                  )
                )
              }
              callback()
            },
            trigger: 'blur',
          },
        ],
        product_url: [
          {
            validator: (rule, value, callback) => {
              if(this.noApp){
                callback(new Error('App is not found in store.'))
              }
              
              if(value){
                var domain = value.split('/'); 
                if(domain[2]==='play.google.com'){
                  callback()
                }else{
                  /* eslint-disable standard/no-callback-literal */
                  callback('Please enter the correct store url.')
                }
              }
              if ((!this.regist.country && !value) || (this.regist.country && value) || !value) {
                callback()
              }
              callback(new Error(this.$t('messages.tipError.emptyErr')))
            },
            trigger: 'blur',
          },
        ],
        contact_number: [
          this.createRequiredRule(this,'messages.tipError.emptyErr'),
        ],
        country: [this.createRequiredRule(this,'messages.tipError.emptyErr'),],
        phone: [
          this.createRequiredRule(this,'messages.register.phoneFormatErr'),
          {
            validator: (rule, value, callback) => {
              const regex = /\D/
              let phoneRegex = /^1[3-9]\d{9}$/ // 手机号正则表达式
              if (this.area !== 'CN') {
                if (regex.test(value)) {
                  return callback(new Error(this.$t('messages.register.phoneErr1')))
                } else if (value.length > 20) {
                  return callback(new Error(this.$t('messages.register.phoneErr3')))
                } else {
                  callback()
                }
              } else {
                if (!phoneRegex.test(value)) {
                  if (regex.test(value)) {
                    return callback(new Error(this.$t('messages.register.phoneErr1')))
                  } else {
                    return callback(new Error(this.$t('messages.register.phoneErr2')))
                  }
                } else {
                  callback()
                }
              }
            },
            trigger: 'blur',
          },
        ],
        email: [
          this.createRequiredRule(this,'messages.tipError.emptyErr'),
          // {
          //   type: 'email',
          //   message: this.$t('messages.register.emailFormatErr'),
          //   trigger: ['blur', 'change'],
          // },
          this.createRequiredRule2(this,'messages.gLogin.urlErr',undefined,'email'),
        ],
      },
      
      applicationsEN: [
        { label: 'WhatsApp', value: 3, src: require('../assets/img/WhatsApp.png') },
        { label: 'Teams', value: 1, src: require('../assets/img/Teams.png') },
        { label: 'Telegram', value: 5, src: require('../assets/img/Telegram.png') },
        { label: 'WeChat', value: 7, src: require('../assets/img/WeChat.png') },
        { label: 'Phone', value: 8, src: require('../assets/img/Phone-b.png') },
      ],
      applicationsCN: [
        { label: 'WhatsApp', value: 3, src: require('../assets/img/WhatsApp.png') },
        { label: '团队', value: 1, src: require('../assets/img/Teams.png') },
        { label: 'Telegram', value: 5, src: require('../assets/img/Telegram.png') },
        { label: '微信', value: 7, src: require('../assets/img/WeChat.png') },
        { label: '手机', value: 8, src: require('../assets/img/Phone-b.png') },
      ],
      // countryOptions: this.initSelectOptions(countryAll),
      selectOptionWidth: null,
      areaCodeList: [],
      AppOptions: [],
      search: '',
      noApp: false,
    }
  },
  watch: {
    '$i18n.locale': function() {
      this.setFormRules()
      this.$nextTick(() => {
        if (this.$refs['registerForm']) {
          this.$refs['registerForm'].fields.forEach(item => {
            item.clearValidate()
          })
        }
      })
    },
    'regist.country': function(newVal) {
      let selectedOption = this.AppOptions.find(option => option.gp_url === this.regist.product_url)
      if (selectedOption) {
        let search = selectedOption.pkg
        if (!newVal || !this.regist.product_url) return
        let params = {
          app: search,
          country: newVal,
        }
        this.getAppListPost(params)
      }
    },
    'regist.product_url': function(newVal) {
      let selectedOption = this.AppOptions.find(option => option.gp_url === newVal)
      if (selectedOption) {
        // let search = selectedOption.pkg
        if (!newVal || !this.regist.country) return
        // let params = {
        //   app: search,
        //   country: this.regist.country
        // }
        // this.getAppListPost(params)
        this.$set(this.selectObj, 'imgUrl', selectedOption.icon)
      }
    },
  },
  computed: {
    isEnglish(){
      return this.$i18n.locale === 'en'
    },
    countryOptions(){
      if(this.isEnglish){
        return this.initSelectOptions(countryAll)
      }
      return this.initSelectOptions(countryAllCN)
    },
    applications(){
      if(this.isEnglish){
        return this.applicationsCN
      }
      return this.applicationsEN
    },
    areaPhone() {
      let str = ''
      let phone = this.regist.phone
      let newPhone = ''
      let country = this.areaCodeList.filter(row => row.country === this.area)
      if (country.length > 0 && this.regist.phone) {
        str = country[0].code
        newPhone = str + phone
      }
      return newPhone
    },
    ...mapGetters(['holidayNow']),
  },
  created() {
    this.$nextTick(() => {
      this.changeContactType(3)
    })
    this.getAreaCodeList()
  },
  methods: {
    handleUrlInput(){
      this.urlErr = false
    },
    searchGP(params){
      this.$http
      .get('/api/applications/gpinfo/', { params })
      .then(res => {
        if (res.data.application) {
          const data = res.data.application
        }else{
          this.noApp = true
        }
      })
      .catch(() => {
        // this.loading = false
      })
    },
    changeURLArg(url,arg,arg_val){ 
      var pattern=arg+'=([^&]*)'; 
      var replaceText=arg+'='+arg_val; 
      if(url.match(pattern)){ 
        var tmp='/('+ arg+'=)([^&]*)/gi'; 
        tmp=url.replace(this.evil(tmp),replaceText); 
        return tmp; 
      }else{ 
        if(url.match('[\?]')){ // eslint-disable-line
          return url+'&'+replaceText; 
        }else{ 
          return url+'?'+replaceText; 
        } 
      } 
    } ,
    changeAppStoreUrl(){
      this.urlErr = false
      let value = this.regist.product_url
      if(value === ''){
        this.noApp = false
        return
      }
      console.log('changeAppStoreUrl',this.regist.product_url);
      this.$refs.registerForm.validateField('product_url', error => {
        if (!error) {
          let newUrl = value
          let gl = this.regist.country.toLowerCase()
          let hl=''
          newUrl = this.changeURLArg(newUrl,'gl',gl);
          if(gl==='id'){
            hl = 'id'
          }else{
            hl='en'
          }
          newUrl = this.changeURLArg(newUrl,'hl',hl);
          let params = {
            country: this.regist.country,
            pre_info: newUrl,
            gl,
            hl,
            is_need_screenshot:1
          }
          this.searchGP(params)
        }
      })
    },
    getAppListPost(params) {
      this.$http
        .post('/api/applications/gpsearch/', params)
        .then(data => {
          this.AppOptions = data.data
          if (this.AppOptions.length === 0) {
            this.$set(this.regist, 'product_url', '')
          }
        })
        .catch(err => {
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    getAppList: debounce(function(search) {
      if (!search || !this.regist.country) return
      let params = {
        app: search,
        country: this.regist.country,
      }
      this.getAppListPost(params)
    }, 500),
    getAreaCodeList() {
      this.$http
        .get('/api/accounts/get_phone_area_code/')
        .then(data => {
          this.areaCodeList = data.data
          this.area = data.country
          this.$set(this.regist, 'country', data.country)
        })
        .catch(err => {
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    handleSetOptionWidth(event) {
      this.$nextTick(() => {
        this.selectOptionWidth = event.srcElement.offsetWidth + 'px'
      })
    },
    signUpPost: debounce(function() {
      let params = { ...this.regist, phone: this.areaPhone }
      if(this.$store.state.profile.email){
        params = omit(params,['email'])
      }
      this.loading = true
      this.$http
        .post('/api/accounts/fill-info-after-register/', params)
        .then(() => {
          this.loading = false
          this.notifyOpen('Success', this.$t('messages.createCampaign.create154'))
          this.$store.commit('UPDATE_NEED_FILL', false)
          this.$emit('getProfile')
        })
        .catch(error => {
          this.loading = false
          this.notifyOpen('Error', this.executeError(error), 'error')
        })
    }, 350),
    signUp() {
      this.$refs['registerForm'].validate(valid => {
        if (valid) {
          this.signUpPost()
          // if (!this.regist.product_url) {
          //   this.$emit('changeDialog', true)
          // } else {
          //   this.signUpPost()
          // }
        }
      })
    },
    changeContactType(value) {
      let path = this.applications.find(item => item.value === value).src
      if (this.$refs.contact_type) {
        this.$refs.contact_type.$el.children[0].setAttribute(
          'style',
          `background: url(${path}) no-repeat; background-size: 16px;background-position: 9px 16px;`
        )
      }
    },
  },
}
</script>

<style lang="scss">
.regist-form {
  .form-label {
    display: inline-block;
    color: #606266;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 8px;
  }
  .application-number {
    .el-select {
      .el-input {
        background: url('../assets/img/Teams.png') no-repeat;
        background-size: 16px;
        background-position: 9px 16px;
      }
      .el-input__inner {
        text-indent: 20px;
        border-color: transparent !important;
      }
      .el-input__icon.el-input__validateIcon {
        display: none;
        color: transparent !important;
      }
    }
  }
  .el-input-group__prepend {
    .el-input {
      width: auto;
    }
  }
  .apps-options-item {
    .item1 {
      width: 142px;
      .el-input__inner {
        border-radius: 4px 0 0 4px;
        border-right-width: 0.5px;
      }
    }
    .item2 {
      width: 319px;
      .el-input__inner {
        border-radius: 0 4px 4px 0;
        border-left-width: 0.5px;
      }
    }
    .el-input__prefix {
      display: flex;
      align-items: center;
    }
  }
}
.register {
  .el-input-group__prepend {
    .el-input {
      width: 142px;
    }
  }
}
.register-form-com .application-number2 .el-select .el-input {
  background: inherit !important;
  .el-input__inner {
    padding-left: 0 !important;
  }
}
.register-form-com {
  margin: 0 auto;
  width: 462px;
  .pop-title {
    font-weight: 600;
    font-size: 28px;
    color: #303133;
    line-height: 46px;
    text-align: left;
    margin-bottom: 14px;
  }
  .signup-btn {
    padding: 12px;
    width: 100%;
    background: #e30077;
    border-radius: 4px;
    font-size: 20px;
    color: #ffffff;
    border-color: #e30077;
  }
  .app-select-option {
    display: flex;
    align-items: center;
    .img {
      width: 22px;
      height: 22px;
      margin-right: 8px;
    }
    .country,
    .name {
      height: 22px;
      font-size: 14px;
      font-weight: 400;
      color: #606266;
      line-height: 22px;
    }
    .country {
      margin-right: 4px;
    }
  }
  .app-select-prefix-icon {
    display: flex;
    align-items: center;
    > img {
      width: 22px;
      height: 22px;
      margin-right: 8px;
    }
    .country,
    .name {
      color: #37383a;
      font-size: 14px;
    }
    .country {
      margin-right: 4px;
    }
  }
}
.area-code-select {
  width: 142px;
  .option-p {
    display: flex;
    justify-content: space-between;
  }
}

@media screen and (max-width: 766px) {
}
</style>
